import React, { useCallback, useEffect, useState } from "react";
import { FiSettings, FiTrash } from "react-icons/fi";
import styles from "./StaffTable.module.css";
import AddPositionPanel from "./AddPositionPanel";
import { API_URL } from "../../config/api";

const StaffPositions = () => {
  const [positions, setPositions] = useState([]);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [selectedPositionTitle, setSelectedPositionTitle] = useState("");

  const token = localStorage.getItem("token");

  const fetchPositions = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/roles`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (Array.isArray(data.data)) {
        setPositions(data.data);
        localStorage.setItem("roles", JSON.stringify(data.data));
      }
    } catch (error) {
      const saved = localStorage.getItem("roles");
      if (saved) setPositions(JSON.parse(saved));
    }
  }, [token]);

  useEffect(() => {
    if (token) fetchPositions();
  }, [token, fetchPositions]);

  const handleClosePanel = () => {
    setIsPanelOpen(false);
    setSelectedPositionId(null);
    setSelectedPositionTitle("");
    fetchPositions();
  };

  const handleTitleClick = (id) => {
    const pos = positions.find((p) => p.id === id);
    setSelectedPositionId(id);
    setSelectedPositionTitle(pos ? pos.title : "");
    setIsPanelOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      const res = await fetch(`${API_URL}/api/roles/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.ok) {
        setPositions((prev) => prev.filter((p) => p.id !== id));
      } else {
        console.error("Ошибка при удалении должности");
      }
    } catch (err) {
      console.error("Ошибка при удалении:", err);
    }
  };

  return (
    <div className={styles.container}>
      <button className={styles.add} onClick={() => setIsPanelOpen(true)}>
        +
      </button>

      {isPanelOpen && (
        <AddPositionPanel
          onClose={handleClosePanel}
          positionId={selectedPositionId}
          positionTitle={selectedPositionTitle}
        />
      )}

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Название должности</th>
            <th>Количество сотрудников</th>
            <th>
              <FiSettings size={18} />
            </th>
          </tr>
        </thead>
        <tbody>
          {positions.map((pos) => (
            <tr key={pos.id}>
              <td className={styles.clickable} onClick={() => handleTitleClick(pos.id)}>
                {pos.title}
              </td>
              <td>{pos.users_num || 0}</td>
              <td className={styles.iconCell}>
                <FiTrash
                  size={20}
                  style={{ cursor: "pointer", color: "gray" }}
                  onClick={() => handleDelete(pos.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaffPositions;
